import { render, staticRenderFns } from "./PropertyStatusBadgeComponent.vue?vue&type=template&id=9e4ab1f4"
import script from "./PropertyStatusBadgeComponent.vue?vue&type=script&lang=js"
export * from "./PropertyStatusBadgeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports